module.exports = __webpack_public_path__ + "img/fatherhood_11.4f667845.jpg";